import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class InaReportService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    searchINAReports(payload: any): Observable<any> {
    
        console.log("payload coming in:")
        console.log(payload)
        // fix for auth
        const authObject = this.urlProvider.baseGetOptions();
        var headers = {
            'Access-Control-Allow-Origin':environment.headerHost,
            'Content-Type':'application/json',
            'Accept':'*/*',
            'responseType':'text' as 'json',
            'Authorization':authObject.headers.lazyUpdate[2].value
        }
    
        ////////// 
       /* let urlParam = '?';

        urlParam += 'chosenRegions=' + (payload.chosenRegions ? payload.chosenRegions : '');
        urlParam += '&chosenCounties=' + (payload.chosenCounties ? payload.chosenCounties : '');
        urlParam += '&chosenSchoolDistricts=' + (payload.chosenSchoolDistricts ? payload.chosenSchoolDistricts : '');
        urlParam += '&chosenSchools=' + (payload.chosenSchools ? payload.chosenSchools : '');
        urlParam += '&schoolYear=' + (payload.schoolYear ? payload.schoolYear : '');

        urlParam += '&enrollmentTypes=' + (payload.enrollmentTypes ? payload.enrollmentTypes : '');

        urlParam += '&withoutEip=' + (payload.withoutEip ? payload.withoutEip : '0');
        urlParam += '&expiredQad=' + (payload.expiredQad ? payload.expiredQad : '0');
        urlParam += '&withoutIna=' + (payload.withoutIna ? payload.withoutIna : '0');

        urlParam += '&filterCategory=' + (payload.filterCategory ? payload.filterCategory : '');
        */

        let params = new HttpParams();
        params = params.append('chosenRegions', (payload.chosenRegions ? payload.chosenRegions : ''));
        params = params.append('chosenCounties', (payload.chosenCounties ? payload.chosenCounties : ''));
        params = params.append('chosenSchoolDistricts', (payload.chosenSchoolDistricts ? payload.chosenSchoolDistricts : ''));
        params = params.append('chosenSchools', (payload.chosenSchools ? payload.chosenSchools : ''));
        params = params.append('schoolYear', (payload.schoolYear ? payload.schoolYear : ''));
        params = params.append('enrollmentTypes',(payload.enrollmentTypes ? payload.enrollmentTypes : ''));
        params = params.append('withoutEip' , (payload.withoutEip ? payload.withoutEip : '0'));
        params = params.append('expiredQad', (payload.withoutEip ? payload.withoutEip : '0'));
        params = params.append('withoutIna', (payload.withoutIna ? payload.withoutIna : '0'));
        params = params.append('filterCategory', (payload.filterCategory ? payload.filterCategory : ''));
        console.log("ina report search calling url: ")
        console.log(params)
        console.log(headers)
        console.log(EndPoints.inaReports_searchINAReports) // undefined, urlParam
        /*
        
            chosenRegions: (payload.chosenRegions ? payload.chosenRegions : ''),
            chosenCounties: (payload.chosenCounties ? payload.chosenCounties : ''),
            chosenSchoolDistricts:  (payload.chosenSchoolDistricts ? payload.chosenSchoolDistricts : ''),
            chosenSchools: (payload.chosenSchools ? payload.chosenSchools : ''),
            schoolYear: (payload.chosenPerformancePeriod ? payload.chosenPerformancePeriod : ''),
            enrollmentTypes: (payload.enrollmentTypes ? payload.enrollmentTypes : ''),
            withoutEip: (payload.withoutEip ? payload.withoutEip : '0'),
            expiredQad: (payload.withoutEip ? payload.withoutEip : '0'),
            withoutIna: (payload.withoutIna ? payload.withoutIna : '0'),
            filterCategory: (payload.filterCategory ? payload.filterCategory : '')
            
            */
        return this.post<any>(EndPoints.inaReports_searchINAReports,true, '', {
            chosenRegions: (payload.chosenRegions ? payload.chosenRegions : ''),
            chosenCounties: (payload.chosenCounties ? payload.chosenCounties : ''),
            chosenSchoolDistricts:  (payload.chosenSchoolDistricts ? payload.chosenSchoolDistricts : ''),
            chosenSchools: (payload.chosenSchools ? payload.chosenSchools : ''),
            schoolYear: (payload.schoolYear ? payload.schoolYear : ''),
            enrollmentTypes: (payload.enrollmentTypes ? payload.enrollmentTypes : ''),
            withoutEip: (payload.withoutEip ? payload.withoutEip : '0'),
            expiredQad: (payload.withoutEip ? payload.withoutEip : '0'),
            withoutIna: (payload.withoutIna ? payload.withoutIna : '0'),
            filterCategory: (payload.filterCategory ? payload.filterCategory : '')
        
        }
         ).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['inaReports'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );

    }
}
